import { render } from "./AdminFooter.vue?vue&type=template&id=69f32dfa&scoped=true"
import script from "./AdminFooter.vue?vue&type=script&lang=js"
export * from "./AdminFooter.vue?vue&type=script&lang=js"

import "./AdminFooter.vue?vue&type=style&index=0&id=69f32dfa&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f32dfa"]])

export default __exports__